import { render } from "./PricingComponent.vue?vue&type=template&id=509ae272"
import script from "./PricingComponent.vue?vue&type=script&lang=js"
export * from "./PricingComponent.vue?vue&type=script&lang=js"

import "./PricingComponent.vue?vue&type=style&index=0&id=509ae272&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__